// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 763) return "common/chunk/64ba2b80f0d96f51e4f9.js";
	// return url for filenames based on template
	return undefined;
};